import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { getRemoteConnectionListenerSaga } from './get-remote-connection';
import { loadRemoteConnectionsForDevBoxesListenerSaga } from './load-remote-connections-for-dev-boxes';

export function* rootSaga(): SagaIterator {
    yield all([fork(loadRemoteConnectionsForDevBoxesListenerSaga), fork(getRemoteConnectionListenerSaga)]);
}
